import {
  PageContainer as AntdPageContainer,
  PageContainerProps as AntdPageContainerProps,
} from '@ant-design/pro-components';
import { Breadcrumb, Popconfirm } from 'antd';
import { useLayoutEffect, useMemo, useState } from 'react';
import WrapperButton, { WrapperButtonProps } from '../Button';

export interface PageContainerProps extends AntdPageContainerProps {
  children: React.ReactNode;
  actionButtons?: Array<
    WrapperButtonProps & {
      popconfirm?: {
        title: string;
        description?: string;
        okText?: string;
        cancelText?: string;
        onOk?: () => void;
        style?: React.CSSProperties;
        className?: string;
      };
    }
  >;
}

export const PageContainer = ({ children, actionButtons, ...rest }: PageContainerProps) => {
  const [headerHeight, setHeaderHeight] = useState(0);
  useLayoutEffect(() => {
    const updateHeaderHeight = () => {
      const header = document.querySelector('.ant-layout-header');
      const pageHeader = document.querySelector('.ant-page-header');

      if (header && pageHeader) {
        setHeaderHeight(header.clientHeight + pageHeader.clientHeight);
      }
    };

    updateHeaderHeight();

    const resizeObserver = new ResizeObserver(() => {
      updateHeaderHeight();
    });

    const header = document.querySelector('.ant-layout-header');
    const pageHeader = document.querySelector('.ant-page-header');

    if (header) {
      resizeObserver.observe(header);
    }
    if (pageHeader) {
      resizeObserver.observe(pageHeader);
    }

    // Cleanup
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  const childrenContentStyle = useMemo(() => {
    return {
      minHeight: `calc(100vh - ${headerHeight}px - 13px)`, //13 :margin bottom of children content
      padding: 0,
    };
  }, [headerHeight]);

  return (
    <AntdPageContainer
      {...rest}
      childrenContentStyle={{ ...childrenContentStyle, ...rest.childrenContentStyle }}
      tags={rest.tags}
      breadcrumbRender={data => {
        return (
          <div className='page-container-breadcrumb'>
            <Breadcrumb {...data.breadcrumb} />
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {actionButtons?.map((button, index) => {
                const buttonElement = <WrapperButton {...button} key={index} />;

                if (button.popconfirm) {
                  return (
                    <Popconfirm
                      key={index}
                      title={button.popconfirm.title}
                      description={button.popconfirm.description}
                      onConfirm={button.popconfirm.onOk}
                      okText={button.popconfirm.okText || 'Có'}
                      cancelText={button.popconfirm.cancelText || 'Không'}
                      placement='bottomLeft'
                    >
                      {buttonElement}
                    </Popconfirm>
                  );
                }

                return buttonElement;
              })}
            </div>
          </div>
        );
      }}
    >
      {children}
    </AntdPageContainer>
  );
};
